export default class Pageable{
  /**
   * Filtre de pagination
   * @param {number} page la page
   * @param {number} size la taille de la page
   * @param {String} sort le champ de tri
   */
    constructor({
        page = 0,
        size = 20,
        sort = null,
                }) {
        this.page = page;
        this.size = size;
        this.sort = sort;
    }
}
